import { useQuery } from "@tanstack/react-query";
import { fetchComponentById } from "../../api/maintenance/componentService";

export const useComponentDetails = (comId) => {
    const isValidId = Number.isInteger(comId) && comId > 0;

    return useQuery({
        queryKey: ["component", comId],
        queryFn: async () => {
            if (!isValidId) {
                throw new Error("ID de componente inválido. La consulta no debería haberse activado.");
            }
            return fetchComponentById(comId);
        },
        enabled: isValidId,

        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,        
        
        retry: (failureCount, error) => {
            if (error.message && error.message.includes('Missing queryFn')) {
                return false;
            }
            return failureCount < 3;
        },
        onSettled: (data, error, status) => {
            if (data && error && error.message && error.message.includes('Missing queryFn')) {
                console.warn("useComponentDetails: Ignored a 'Missing queryFn' error because data was successfully retrieved.");                
            }
        },
    });
};